/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q13Inputs */

const et_faq_q13 = /** @type {(inputs: Faq_Q13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Millised vead Eesti ettevõtete kodulehtedel kõige rohkem päringuid kaotavad?`)
};

const en_faq_q13 = /** @type {(inputs: Faq_Q13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which website mistakes cause Estonian companies to lose the most inquiries?`)
};

/**
* | output |
* | --- |
* | "Which website mistakes cause Estonian companies to lose the most inquiries?" |
*
* @param {Faq_Q13Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q13 = /** @type {((inputs?: Faq_Q13Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q13Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q13(inputs)
	return en_faq_q13(inputs)
});